"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HumidityConversions = require("./humidity-conversions");
var MoistAirHelper = require("./moist-air-helper");
var uom_1 = require("uom");
var uom_units_1 = require("uom-units");
var _1 = require(".");
// RelativeHumidity to WetTemperature
function relativeHumidityToWetTemperature(pressure, temperature, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature);
    var rh = uom_1.Amount.valueAs(uom_units_1.Units.PercentHumidity, humidity);
    var W = HumidityConversions.To_HumidityRatio_From_RelativeHumidity(p, t, rh);
    // tslint:disable-next-line:variable-name
    var t_wb = HumidityConversions.From_HumidityRatio_To_WetBulb(p, t, W);
    return uom_1.Amount.create(t_wb, uom_units_1.Units.CelsiusWet);
}
exports.relativeHumidityToWetTemperature = relativeHumidityToWetTemperature;
// RelativeHumidity to HumidityRatio
function relativeHumidityToHumidityRatio(pressure, temperature, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature);
    var rh = uom_1.Amount.valueAs(uom_units_1.Units.PercentHumidity, humidity);
    var W = HumidityConversions.To_HumidityRatio_From_RelativeHumidity(p, t, rh);
    return uom_1.Amount.create(W, uom_units_1.Units.KilogramPerKilogram);
}
exports.relativeHumidityToHumidityRatio = relativeHumidityToHumidityRatio;
// RelativeHumidity to SpecificEnthalpy
function relativeHumidityToSpecificEnthalpy(pressure, temperature, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature);
    var rh = uom_1.Amount.valueAs(uom_units_1.Units.PercentHumidity, humidity);
    var h = HumidityConversions.From_RelativeHumidity_To_SpecificEnthalpy(p, t, rh);
    return uom_1.Amount.create(h, uom_units_1.Units.KilojoulePerKilogram);
}
exports.relativeHumidityToSpecificEnthalpy = relativeHumidityToSpecificEnthalpy;
// RelativeHumidity to DewPointTemperature
function relativeHumidityToDewPointTemperature(pressure, temperature, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature);
    var rh = uom_1.Amount.valueAs(uom_units_1.Units.PercentHumidity, humidity);
    var W = HumidityConversions.To_HumidityRatio_From_RelativeHumidity(p, t, rh);
    // tslint:disable-next-line:variable-name
    var t_dp = HumidityConversions.From_HumidityRatio_To_DewPoint(p, W);
    return uom_1.Amount.create(t_dp, uom_units_1.Units.CelsiusDewPoint);
}
exports.relativeHumidityToDewPointTemperature = relativeHumidityToDewPointTemperature;
// SpecificEnthalpy to WetTemperature
function specificEnthalpyToWetTemperature(pressure, temperature, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature);
    var h = uom_1.Amount.valueAs(uom_units_1.Units.KilojoulePerKilogram, humidity);
    var W = HumidityConversions.To_HumidityRatio_From_Enthalpy(p, t, h);
    // tslint:disable-next-line:variable-name
    var t_wb = HumidityConversions.From_HumidityRatio_To_WetBulb(p, t, W);
    return uom_1.Amount.create(t_wb, uom_units_1.Units.CelsiusWet);
}
exports.specificEnthalpyToWetTemperature = specificEnthalpyToWetTemperature;
// SpecificEnthalpy to HumidityRatio
function specificEnthalpyToHumidityRatio(pressure, temperature, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature);
    var h = uom_1.Amount.valueAs(uom_units_1.Units.KilojoulePerKilogram, humidity);
    var W = HumidityConversions.To_HumidityRatio_From_Enthalpy(p, t, h);
    return uom_1.Amount.create(W, uom_units_1.Units.KilogramPerKilogram);
}
exports.specificEnthalpyToHumidityRatio = specificEnthalpyToHumidityRatio;
// SpecificEnthalpy to RelativeHumidity
function specificEnthalpyToRelativeHumidity(pressure, temperature, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature);
    var h = uom_1.Amount.valueAs(uom_units_1.Units.KilojoulePerKilogram, humidity);
    var W = HumidityConversions.To_HumidityRatio_From_Enthalpy(p, t, h);
    var rh = HumidityConversions.From_HumidityRatio_To_RelativeHumidity(p, t, W);
    return uom_1.Amount.create(rh, uom_units_1.Units.PercentHumidity);
}
exports.specificEnthalpyToRelativeHumidity = specificEnthalpyToRelativeHumidity;
// SpecificEnthalpy to DewPointTemperature
function specificEnthalpyToDewPointTemperature(pressure, temperature, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature);
    var h = uom_1.Amount.valueAs(uom_units_1.Units.KilojoulePerKilogram, humidity);
    var W = HumidityConversions.To_HumidityRatio_From_Enthalpy(p, t, h);
    // tslint:disable-next-line:variable-name
    var t_dp = HumidityConversions.From_HumidityRatio_To_DewPoint(p, W);
    return uom_1.Amount.create(t_dp, uom_units_1.Units.CelsiusDewPoint);
}
exports.specificEnthalpyToDewPointTemperature = specificEnthalpyToDewPointTemperature;
// HumidityRatio to WetTemperature
function humidityRatioToWetTemperature(pressure, temperature, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature);
    var W = uom_1.Amount.valueAs(uom_units_1.Units.KilogramPerKilogram, humidity);
    // tslint:disable-next-line:variable-name
    var t_wb = HumidityConversions.From_HumidityRatio_To_WetBulb(p, t, W);
    return uom_1.Amount.create(t_wb, uom_units_1.Units.CelsiusWet);
}
exports.humidityRatioToWetTemperature = humidityRatioToWetTemperature;
// HumidityRatio to RelativeHumidity
function humidityRatioToRelativeHumidity(pressure, temperature, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature);
    var W = uom_1.Amount.valueAs(uom_units_1.Units.KilogramPerKilogram, humidity);
    var rh = HumidityConversions.From_HumidityRatio_To_RelativeHumidity(p, t, W);
    return uom_1.Amount.create(rh, uom_units_1.Units.PercentHumidity);
}
exports.humidityRatioToRelativeHumidity = humidityRatioToRelativeHumidity;
// HumidityRatio to SpecificEnthalpy
function humidityRatioToSpecificEnthalpy(pressure, temperature, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature);
    var W = uom_1.Amount.valueAs(uom_units_1.Units.KilogramPerKilogram, humidity);
    var h = HumidityConversions.From_HumidityRatio_To_SpecificEnthalpy(p, t, W);
    return uom_1.Amount.create(h, uom_units_1.Units.KilojoulePerKilogram);
}
exports.humidityRatioToSpecificEnthalpy = humidityRatioToSpecificEnthalpy;
// HumidityRatio to DewPointTemperature
function humidityRatioToDewPointTemperature(pressure, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var W = uom_1.Amount.valueAs(uom_units_1.Units.KilogramPerKilogram, humidity);
    // tslint:disable-next-line:variable-name
    var t_dp = HumidityConversions.From_HumidityRatio_To_DewPoint(p, W);
    return uom_1.Amount.create(t_dp, uom_units_1.Units.CelsiusDewPoint);
}
exports.humidityRatioToDewPointTemperature = humidityRatioToDewPointTemperature;
// WetTemperature to RelativeHumidity
function wetTemperatureToRelativeHumidity(pressure, temperature, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature);
    // tslint:disable-next-line:variable-name
    var t_wb = uom_1.Amount.valueAs(uom_units_1.Units.CelsiusWet, humidity);
    var W = HumidityConversions.To_HumidityRatio_From_WetBulb(p, t, t_wb);
    var rh = HumidityConversions.From_HumidityRatio_To_RelativeHumidity(p, t, W);
    return uom_1.Amount.create(rh, uom_units_1.Units.PercentHumidity);
}
exports.wetTemperatureToRelativeHumidity = wetTemperatureToRelativeHumidity;
// WetTemperature to HumidityRatio
function wetTemperatureToHumidityRatio(pressure, temperature, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature);
    // tslint:disable-next-line:variable-name
    var t_wb = uom_1.Amount.valueAs(uom_units_1.Units.CelsiusWet, humidity);
    var W = HumidityConversions.To_HumidityRatio_From_WetBulb(p, t, t_wb);
    return uom_1.Amount.create(W, uom_units_1.Units.KilogramPerKilogram);
}
exports.wetTemperatureToHumidityRatio = wetTemperatureToHumidityRatio;
// WetTemperature to SpecificEnthalpy
function wetTemperatureToSpecificEnthalpy(pressure, temperature, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature);
    // tslint:disable-next-line:variable-name
    var t_wb = uom_1.Amount.valueAs(uom_units_1.Units.CelsiusWet, humidity);
    var W = HumidityConversions.To_HumidityRatio_From_WetBulb(p, t, t_wb);
    var h = HumidityConversions.From_HumidityRatio_To_SpecificEnthalpy(p, t, W);
    return uom_1.Amount.create(h, uom_units_1.Units.KilojoulePerKilogram);
}
exports.wetTemperatureToSpecificEnthalpy = wetTemperatureToSpecificEnthalpy;
// WetTemperature to DewPointTemperature
function wetTemperatureToDewPointTemperature(pressure, temperature, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature);
    // tslint:disable-next-line:variable-name
    var t_wb = uom_1.Amount.valueAs(uom_units_1.Units.CelsiusWet, humidity);
    var W = HumidityConversions.To_HumidityRatio_From_WetBulb(p, t, t_wb);
    // tslint:disable-next-line:variable-name
    var t_dp = HumidityConversions.From_HumidityRatio_To_DewPoint(p, W);
    return uom_1.Amount.create(t_dp, uom_units_1.Units.CelsiusDewPoint);
}
exports.wetTemperatureToDewPointTemperature = wetTemperatureToDewPointTemperature;
// DewPointTemperature to RelativeHumidity
function dewPointTemperatureToRelativeHumidity(pressure, temperature, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature);
    // tslint:disable-next-line:variable-name
    var t_dp = uom_1.Amount.valueAs(uom_units_1.Units.CelsiusDewPoint, humidity);
    var W = HumidityConversions.To_HumidityRatio_From_DewPoint(p, t_dp);
    var rh = HumidityConversions.From_HumidityRatio_To_RelativeHumidity(p, t, W);
    return uom_1.Amount.create(rh, uom_units_1.Units.PercentHumidity);
}
exports.dewPointTemperatureToRelativeHumidity = dewPointTemperatureToRelativeHumidity;
// DewPointTemperature to SpecificEnthalpy
function dewPointTemperatureToSpecificEnthalpy(pressure, temperature, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature);
    // tslint:disable-next-line:variable-name
    var t_dp = uom_1.Amount.valueAs(uom_units_1.Units.CelsiusDewPoint, humidity);
    var W = HumidityConversions.To_HumidityRatio_From_DewPoint(p, t_dp);
    var h = HumidityConversions.From_HumidityRatio_To_SpecificEnthalpy(p, t, W);
    return uom_1.Amount.create(h, uom_units_1.Units.KilojoulePerKilogram);
}
exports.dewPointTemperatureToSpecificEnthalpy = dewPointTemperatureToSpecificEnthalpy;
// DewPointTmeperature to HumidityRatio
function dewPointTemperatureToHumidityRatio(pressure, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    // tslint:disable-next-line:variable-name
    var t_dp = uom_1.Amount.valueAs(uom_units_1.Units.CelsiusDewPoint, humidity);
    var W = HumidityConversions.To_HumidityRatio_From_DewPoint(p, t_dp);
    return uom_1.Amount.create(W, uom_units_1.Units.KilogramPerKilogram);
}
exports.dewPointTemperatureToHumidityRatio = dewPointTemperatureToHumidityRatio;
// DewPointTemperature to WetTemperature
function dewPointTemperatureToWetTemperature(pressure, temperature, humidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = uom_1.Amount.valueAs(uom_units_1.Units.Celsius, temperature);
    // tslint:disable-next-line:variable-name
    var t_dp = uom_1.Amount.valueAs(uom_units_1.Units.CelsiusDewPoint, humidity);
    var W = HumidityConversions.To_HumidityRatio_From_DewPoint(p, t_dp);
    // tslint:disable-next-line:variable-name
    var t_wb = HumidityConversions.From_HumidityRatio_To_WetBulb(p, t, W);
    return uom_1.Amount.create(t_wb, uom_units_1.Units.CelsiusWet);
}
exports.dewPointTemperatureToWetTemperature = dewPointTemperatureToWetTemperature;
// Temperature from HumidityRatio and RelativeHumidity
function temperatureFromHumidityRatioAndRelativeHumidity(pressure, humidityRatio, relativeHumidity) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var W = uom_1.Amount.valueAs(uom_units_1.Units.KilogramPerKilogram, humidityRatio);
    var rh = uom_1.Amount.valueAs(uom_units_1.Units.PercentHumidity, relativeHumidity);
    var t = MoistAirHelper.To_Temperature_From_HumidityRatio_And_RelativeHumidity(p, W, rh);
    return uom_1.Amount.create(t, uom_units_1.Units.Celsius);
}
exports.temperatureFromHumidityRatioAndRelativeHumidity = temperatureFromHumidityRatioAndRelativeHumidity;
// Temperature from HumidityRatio and SpecificEnthalpy
function temperatureFromHumidityRatioAndSpecificEnthalpy(pressure, humidityRatio, specificEnthalpy) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var W = uom_1.Amount.valueAs(uom_units_1.Units.KilogramPerKilogram, humidityRatio);
    var h = uom_1.Amount.valueAs(uom_units_1.Units.KilojoulePerKilogram, specificEnthalpy);
    var t = MoistAirHelper.To_Temperature_From_HumidityRatio_And_SpecificEnthalpy(p, W, h);
    return uom_1.Amount.create(t, uom_units_1.Units.Celsius);
}
exports.temperatureFromHumidityRatioAndSpecificEnthalpy = temperatureFromHumidityRatioAndSpecificEnthalpy;
// Temperature from RelativeHumidity and SpecificEnthalpy
function temperatureFromRelativeHumidityAndSpecificEnthalpy(pressure, relativeHumidity, specificEnthalpy) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var rh = uom_1.Amount.valueAs(uom_units_1.Units.PercentHumidity, relativeHumidity);
    var h = uom_1.Amount.valueAs(uom_units_1.Units.KilojoulePerKilogram, specificEnthalpy);
    var t = MoistAirHelper.To_Temperature_From_RelativeHumidity_And_SpecificEnthalpy(p, rh, h);
    return uom_1.Amount.create(t, uom_units_1.Units.Celsius);
}
exports.temperatureFromRelativeHumidityAndSpecificEnthalpy = temperatureFromRelativeHumidityAndSpecificEnthalpy;
// Temperature from HumidityRatio and WetTemperature
function temperatureFromHumidityRatioAndWetTemperature(pressure, humidityRatio, wetTemperature) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var W = uom_1.Amount.valueAs(uom_units_1.Units.KilogramPerKilogram, humidityRatio);
    // tslint:disable-next-line:variable-name
    var t_wb = uom_1.Amount.valueAs(uom_units_1.Units.CelsiusWet, wetTemperature);
    var t = MoistAirHelper.To_Temperature_From_HumidityRatio_And_WetBulb(p, W, t_wb);
    return uom_1.Amount.create(t, uom_units_1.Units.Celsius);
}
exports.temperatureFromHumidityRatioAndWetTemperature = temperatureFromHumidityRatioAndWetTemperature;
function findSaturationLineEnthalpyLineIntersection(pressure, specificEnthalpy) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var h = uom_1.Amount.valueAs(uom_units_1.Units.KilojoulePerKilogram, specificEnthalpy);
    var result = MoistAirHelper.Find_Saturation_Line_Enthalpy_Line_Intersection(p, h);
    return {
        t: uom_1.Amount.create(result.t, uom_units_1.Units.Celsius),
        x: uom_1.Amount.create(result.x, uom_units_1.Units.KilogramPerKilogram),
    };
}
exports.findSaturationLineEnthalpyLineIntersection = findSaturationLineEnthalpyLineIntersection;
function getSaturationTemperatureOfWater(pressure) {
    var p = uom_1.Amount.valueAs(uom_units_1.Units.Pascal, pressure);
    var t = _1.IAPWSIF97.Get_Saturation_Temperature_of_Water(p);
    return uom_1.Amount.create(t, uom_units_1.Units.Kelvin);
}
exports.getSaturationTemperatureOfWater = getSaturationTemperatureOfWater;
